import React from 'react';
import L from 'leaflet';
import { FullscreenControl } from 'react-leaflet-fullscreen';
import 'react-leaflet-fullscreen/styles.css';
import { MapContainer, Marker, TileLayer, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'components/map/stylesMap.css';
import 'leaflet-arrowheads';
import EditableGroup from '../../../../../components/map/components/editable-group/EditableGroup';
import CreateGroup from '../../../../../components/map/components/create-group/CreateGroup';
import location from 'assets/icons/location-mission.svg';
import SetBoundsFeature from 'components/map/components/bounds_feature/SetBoundsFeature';
import { useMapConfig } from 'hooks/useMapConfig';
import { DEFAULT_MAP_CONFIG } from 'constants/const/MapConfig';
function createIconMarker(title) {
    return new L.divIcon({
        iconUrl: location,
        iconSize: new L.Point(50.60136138169762, 36.5873165753055),
        iconAnchor: [15, 30],
        html:
            `<img class="div-image" src="${location}"/>` +
            `<span class="div-span">${title || ''}</span>`,
        // popupAnchor: [0, -8],
        // tooltipAnchor: [-1, -40],
        className: 'custom-icon-svg',
    });
}

export default function MissionMap({ center, zoom, geoJSON, onChangeGeoJSON }) {
    const [map, setMap] = React.useState(null);
    const [data, setData] = React.useState('');
    const [lineMarkers, setLineMarkers] = React.useState([]);
    const mapConfig = useMapConfig() || DEFAULT_MAP_CONFIG;

    // React.useEffect(() => {
    //     if (!map || !!geoJSON || geoJSON?.features?.length !== 0) return;
    //     map.setView(center);
    //     map.flyTo(center);
    // }, [map, center, geoJSON]);

    React.useEffect(() => {
        if (!geoJSON || geoJSON.features.length === 0) {
            setData('');
            setLineMarkers([]);
            return;
        }
        setData(geoJSON);
        geoJSON.features.forEach(feature => {
            if (feature.geometry.type !== 'LineString') return;
            setLineMarkers(prevMarkers =>
                prevMarkers.concat(feature.properties.items),
            );
        });
        return () => setLineMarkers([]);
    }, [geoJSON]);

    const handleChangeFeatureGroup = data => {
        onChangeGeoJSON(data);
    };

    return (
        <>
            {!mapConfig ? null : (
                <MapContainer
                    center={mapConfig?.center}
                    zoom={mapConfig?.zoom}
                    className="map-container"
                    trackResize={true}
                    ref={setMap}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {!data ? null : data?.features?.length === 0 ||
                      data?.features[0].geometry.coordinates.length === 0 ? (
                        <CreateGroup onChange={handleChangeFeatureGroup} />
                    ) : (
                        <EditableGroup
                            data={data}
                            map={map}
                            onChange={handleChangeFeatureGroup}
                        />
                    )}
                    {lineMarkers.length > 0 &&
                        lineMarkers.map((item, index) => {
                            return (
                                <Marker
                                    key={index}
                                    position={[item.lon, item.lat]}
                                    icon={createIconMarker(item?.ordinal)}
                                >
                                    {item?.alt && (
                                        <Tooltip
                                            direction="right"
                                            opacity={0.7}
                                            className={'leaflet-tooltip-own'}
                                            permanent
                                        >
                                            {
                                                // Number(+data[field.key]).toFixed(field.decimal)

                                                Math.ceil(
                                                    Number.parseFloat(
                                                        item?.alt,
                                                    ),
                                                ) || ''
                                            }
                                        </Tooltip>
                                    )}
                                </Marker>
                            );
                        })}
                    <FullscreenControl
                        title={'Full screen mode'}
                        titleCancel={'Exit full screen mode'}
                    />
                    <SetBoundsFeature data={geoJSON} />
                </MapContainer>
            )}
        </>
    );
}
